import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule as NgFormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from '../date-picker/date-picker.module';
import { FormsModule as SppFormsModule } from '../forms/forms.module';
import { IconButtonModule } from '../icon-buttons/icon-button.module';
import { KeyboardModule } from '../keyboard/keyboard.module';
import { PaginationModule } from '../pagination/pagination.module';
import { TableDateRangeFilterComponent } from './filter/table-date-range-filter.component';
import { TableMultiSelectFilterComponent } from './filter/table-multi-select-filter.component';
import { TableTextFilterComponent } from './filter/table-text-filter.component';
import { TableCellDirective, TableColumnDirective, TableFilterCellDirective } from './table-column.directive';
import { TablePaginationComponent } from './table-pagination.component';
import { TableDataRowDirective } from './table-row.directive';
import { TableSortedDirective } from './table-sorted.directive';
import { TableComponent } from './table.component';

export const TABLE_MODULE_DECLARATIONS = [
    TableComponent,
    TableSortedDirective,
    TablePaginationComponent,
    TableMultiSelectFilterComponent,
    TableDateRangeFilterComponent,
    TableTextFilterComponent,
    TableColumnDirective,
    TableDataRowDirective,
    TableCellDirective,
    TableFilterCellDirective
];
export const TABLE_MODULE_EXPORTS = [
    TableComponent,
    TableColumnDirective,
    TableDataRowDirective,
    TableCellDirective,
    TableFilterCellDirective
];

@NgModule({
    imports: [
        CommonModule,
        NgFormsModule,
        ReactiveFormsModule,
        OverlayModule,
        SppFormsModule,
        PaginationModule,
        DatePickerModule,
        IconButtonModule,
        KeyboardModule,
    ],
    declarations: TABLE_MODULE_DECLARATIONS,
    exports: TABLE_MODULE_EXPORTS
})
export class TableModule {

}
